/**
 * @description HeatmapHeader component
 * @file
 * @copyright © Copyright IBI Group., created 2019. All use, disclosure, and/or reproduction of this material is prohibited unless authorized in writing. All rights reserved.
 * @module components/HeatmapHeader
 */

import React from 'react';
import PropTypes from 'prop-types';

/**
 * @description The HeatmapHeader component.
 * @class
 * @extends {React.Component}
 */
class HeatmapHeader extends React.Component {
    
    /**
     * @inheritdoc
     */
    shouldComponentUpdate(nextProps) {
        return (
            JSON.stringify(this.props.junctions) !==
                JSON.stringify(nextProps.junctions) ||
            JSON.stringify(this.props.links) !== JSON.stringify(nextProps.links)
        );
    }

    /**
     * @inheritdoc
     */
    render() {
        return (
            <div className='HeatmapHeader'>
                <div className='HeatmapHeader-direction'>
                    {this.props.direction}
                </div>
                {this.props.links.map(link => this.renderLink(link))}
            </div>
        );
    }

    renderLink(link) {
        const junctions = this.props.junctions.filter(
                junction => junction.linkId === link.id
            ),
            className = `HeatmapHeader-text-container${
                junctions.length === 1 && junctions[0].offsetPercent > 50
                    ? ' justify-end'
                    : junctions.length === 1 &&
                      junctions[0].offsetPercent === 50
                    ? ' justify-center'
                    : ''
            }`;

        return (
            <div
                className={className}
                style={{
                    width: `${(link.lengthMetres / this.props.totalDistance) *
                        100}%`
                }}
                key={link.id}
            >
                {junctions.map(junction => (
                    <div key={junction.name}>
                        <div
                            className={`HeatmapHeader-text${
                                junction.isJunction ? '' : ' label'
                            }`}
                        >
                            <div
                                onMouseOver={this.handleMouseOverJunction.bind(
                                    this,
                                    junction
                                )}
                                onMouseOut={this.props.closeTooltip}
                            >
                                {junction.label}
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        );
    }

    /**
     * @description Handles the hovering of the mouse over a junction.
     * @param {Object} junction - The junction.
     * @param {Object} event - The mouseover event.
     */
    handleMouseOverJunction(junction, event) {
        event.persist();
        this.props.openTooltip(event, junction);
    }
}

HeatmapHeader.defaultProps = {
    totalDistance: 0,
    direction: '',
    links: [],
    junctions: [],
    openTooltip: () => null,
    closeTooltip: () => null
};

HeatmapHeader.propTypes = {
    totalDistance: PropTypes.number.isRequired,
    direction: PropTypes.string.isRequired,
    links: PropTypes.array.isRequired,
    junctions: PropTypes.array.isRequired,
    openTooltip: PropTypes.func.isRequired,
    closeTooltip: PropTypes.func.isRequired
};

export default HeatmapHeader;
